module.exports = __webpack_public_path__ + "img/skridsko_skymning.c9a97dba.jpg";